import React from "react";
import Asset from "../../modules/Marketplace/Asset/Asset";
import { dehydrate, QueryClient } from "react-query";
import {
  getPrefetchQueryWrapper,
  getQueryParam,
} from "../../helpers/nextHelper";
import { QueryKeys } from "../../common/queryKeys";
import { fetchAssetInfo } from "../../queries/asset.query";
import { IMusic } from "../../common/commonTypes";

const AssetPage = () => <Asset />;

AssetPage.getInitialProps = getPrefetchQueryWrapper(async (ctx) => {
  const musicId = getQueryParam(ctx.query, "musicId")!;
  const listingId = getQueryParam(ctx.query, "listing_id");

  if (!musicId) {
    return {};
  }

  const queryClient = new QueryClient();
  const queryKey = [QueryKeys.assetDetails, { musicId, listingId }];
  await queryClient.prefetchQuery(queryKey, () =>
    fetchAssetInfo(musicId, listingId)
  );
  const { music } =
    queryClient.getQueryData<{ music?: IMusic }>(queryKey) || {};

  return {
    dehydratedState: dehydrate(queryClient),
    initialTheme: music?.artist.profile.theme,
  };
});

export default AssetPage;
